import type { IconProps } from './types';

export const RedoIcon = (props: IconProps) => {
  const {
    width = 17,
    height = 16,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 17 16"
      fill="none"
      className={className}
    >
      <path
        d="M11.1429 1L15.7143 5.57143L11.1429 10.1429"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7143 5.57143H5.42858C2.9039 5.57143 0.857152 7.61813 0.857152 10.1429C0.857152 12.6675 2.9039 14.7143 5.42858 14.7143H8.28572"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
